const initialState = {
    isSortSheetOpen: false,
    isSheetOpen: false,
    filterIndex: false,
    filter: {},
};

const productsMobile = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_BOTTOM_SHEET_PRODUCTS':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default productsMobile;
